import type { JSX } from "solid-js";
import { Dynamic } from "solid-js/web";
import type { GuideStep } from "./StepGuide";

/** 24 × 24 line icons drawn in the current text colour. */
function Icon(props: { size?: number; class?: string; children: JSX.Element }) {
  return (
    <svg class={props.class ?? "icon"} width={props.size ?? 18} height={props.size ?? 18} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      {props.children}
    </svg>
  );
}

type IconProps = { size?: number; class?: string };

/** Tape measure: the case with its tape pulled out and ticked. */
export const MeasureIcon = (props: IconProps) => <Icon {...props}><circle cx="9" cy="10" r="6" /><circle cx="9" cy="10" r="1.6" /><path d="M9 16h12v-3.5" /><path d="M12.5 16v-2M16 16v-2" /></Icon>;

/** Shirt: the garment library. */
export const PatternsIcon = (props: IconProps) => <Icon {...props}><path d="M8.5 3 4 5 2.5 10l3 1.2V21h13v-9.8l3-1.2L20 5l-4.5-2a3.5 3.5 0 0 1-7 0Z" /></Icon>;

/** Set square and curve: drafting the pieces. */
export const WorkspaceIcon = (props: IconProps) => <Icon {...props}><path d="M4 3v17h17Z" /><path d="M8 11v5h5Z" /><path d="M13 3.5c3.5.5 6.5 3.5 7 7" /></Icon>;

export const PrintIcon = (props: IconProps) => <Icon {...props}><path d="M7 8V3h10v5" /><rect x="3" y="8" width="18" height="9" rx="2" /><path d="M7 14h10v7H7Z" /><path d="M17.5 11h.01" /></Icon>;

/** The printer struck through: a piece left out of the print. */
export const NoPrintIcon = (props: IconProps) => <Icon {...props}><path d="M7 8V3h10v5" /><rect x="3" y="8" width="18" height="9" rx="2" /><path d="M7 14h10v7H7Z" /><path d="m3 3 18 18" /></Icon>;

export const HelpIcon = (props: IconProps) => <Icon {...props}><circle cx="12" cy="12" r="9" /><path d="M9.3 9.2a2.8 2.8 0 0 1 5.4 1c0 1.9-2.7 2.3-2.7 4.1" /><path d="M12 17.6h.01" /></Icon>;

export const CheckIcon = (props: IconProps) => <Icon {...props}><path d="m5 12.5 4.5 4.5L19 7.5" /></Icon>;

export const CloseIcon = (props: IconProps) => <Icon {...props}><path d="M6 6l12 12M18 6 6 18" /></Icon>;

export const ArrowRightIcon = (props: IconProps) => <Icon {...props}><path d="M5 12h14M13 6l6 6-6 6" /></Icon>;

export const ArrowLeftIcon = (props: IconProps) => <Icon {...props}><path d="M19 12H5M11 6l-6 6 6 6" /></Icon>;

export function StepIcon(props: IconProps & { step: GuideStep }) {
  const icons = { measurements: MeasureIcon, library: PatternsIcon, workspace: WorkspaceIcon, print: PrintIcon };
  return <Dynamic component={icons[props.step]} size={props.size} class={props.class} />;
}
